/*
 * サブシステム名：マスタ管理
 * 機能名：定型一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdRadioButton from '@/components/DdRadioButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '../../components/DdTextBox.vue'
import DdHacchuKensakuTextBox from '@/components/DdHacchuKensakuTextBox'
import DdSwitch from '@/components/DdSwitch'
import DdDropDown from '@/components/DdDropDown'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

export default {
  name: 'MstTeikeiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      teikeiKihonNo: '',
      teikeiKihonNm: '',
      juchuHacchuCd: '',
      hacchusakiKbnCd: '',
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tantoEigyoshoCd: '',
      torihikisakiCd: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      hinmokuSbtCd: '',
      hinmeiCd: '',
      ikkatsuFlg: false
    },

    /*
    headersTorihikisakiList: [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ],
    */
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdRadioButton,
    DdDataTable,
    DdCodeTextBox,
    DdHacchuKensakuTextBox,
    DdDropDown,
    DdDateBox,
    DdSwitch,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        if (elem.hatsuchiHms) { elem.hatsuchiHms = (elem.hatsuchiHms).slice(0, 5) }
        if (elem.chakuchiHms) { elem.chakuchiHms = (elem.chakuchiHms).slice(0, 5) }
        if (elem.yoteiSagyoJikan) { elem.yoteiSagyoJikan = filter.minToTimeFormatter(elem.yoteiSagyoJikan) }
        if (elem.warimashiTaishoJikan) { elem.warimashiTaishoJikan = filter.minToTimeFormatter(elem.warimashiTaishoJikan) }
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) + '円' }
        if (elem.yoteiSokoKyori) { elem.yoteiSokoKyori = filter.numericFormatter(elem.yoteiSokoKyori) + 'km' }
        if (elem.warimashiTaishoKyori) { elem.warimashiTaishoKyori = filter.numericFormatter(elem.warimashiTaishoKyori) + 'km' }
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) + '円' }
        if (elem.juchuHacchuCd === '01') {
          if (elem.kihonSeikyuKingaku) {
            elem.kihonSeikyuKingaku = filter.numericFormatter(elem.kihonSeikyuKingaku) + '円'
          } else {
            elem.kihonSeikyuKingaku = ''
          }
          if (elem.courseSeikyuKingaku) {
            elem.courseSeikyuKingaku = filter.numericFormatter(elem.courseSeikyuKingaku) + '円'
          } else {
            elem.courseSeikyuKingaku = ''
          }
          elem.kihonShiharaiKingaku = ''
          elem.courseShiharaiKingaku = ''
        } else if (elem.juchuHacchuCd === '02') {
          if (elem.kihonShiharaiKingaku) {
            elem.kihonShiharaiKingaku = filter.numericFormatter(elem.kihonShiharaiKingaku) + '円'
          } else {
            elem.kihonShiharaiKingaku = ''
          }
          if (elem.courseShiharaiKingaku) {
            elem.courseShiharaiKingaku = filter.numericFormatter(elem.courseShiharaiKingaku) + '円'
          } else {
            elem.courseShiharaiKingaku = ''
          }
          elem.kihonSeikyuKingaku = ''
          elem.courseSeikyuKingaku = ''
        }

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun'
    }),
    // 取引先を出力
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    // 卸先を出力
    filteredOroshisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.torihikisakiBunruiKbn1 === '01'
      })
    },
    // 営業所を出力
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地を出力
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品名を出力
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品目種別フィルター
    filteredHinmokuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    // 受発注区分フィルター
    filteredJuchuHacchuKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN018')
    },
    // 発注先区分フィルター
    filteredHacchusakiKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN015')
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstTeikeiList.defineHeaderPromise')
            self.headers = [
              { text: '定型基本番号', value: 'teikeiKihonNo' },
              { text: '定型基本名称', value: 'teikeiKihonNm' },
              { text: '受発注区分', value: 'juchuHacchuNm' },
              { text: '発注先区分', value: 'hacchusakiKbnNm' },
              { text: '定型コース番号', value: 'teikeiCourseNo' },
              { text: '定型コース名称', value: 'teikeiCourseNm' },
              { text: '担当営業所名称', value: 'tantoEigyoshoNm' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '荷主', value: 'ninushiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '発時刻', value: 'hatsuchiHms' },
              { text: '発時刻備考', value: 'hatsuchiHmsBiko' },
              { text: '卸先', value: 'oroshisakiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '着時刻', value: 'chakuchiHms' },
              { text: '着時刻備考', value: 'chakuchiHmsBiko' },
              { text: '予定作業時間', value: 'yoteiSagyoJikan' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan' },
              { text: '割増時間単価', value: 'warimashiJikanTanka', align: 'end' },
              { text: '予定走行距離', value: 'yoteiSokoKyori' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori' },
              { text: '割増距離単価', value: 'warimashiKyoriTanka', align: 'end' },
              { text: '品目種別', value: 'hinmokuSbtNm' },
              { text: '品名', value: 'hinmeiNm' },
              { text: '請求区分', value: 'seikyuKbn' },
              { text: '基本請求金額', value: 'kihonSeikyuKingaku', align: 'end' },
              { text: 'コース請求金額', value: 'courseSeikyuKingaku', align: 'end' },
              { text: '支払区分', value: 'shiharaiKbn' },
              { text: '基本支払金額', value: 'kihonShiharaiKingaku', align: 'end' },
              { text: 'コース支払金額', value: 'courseShiharaiKingaku', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              teikeiKihonNo: '',
              teikeiKihonNm: '',
              juchuHacchuCd: '',
              hacchusakiKbnCd: '',
              teikeiCourseNo: '',
              teikeiCourseNm: '',
              tantoEigyoshoCd: '',
              torihikisakiCd: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              hinmokuSbtCd: '',
              hinmeiCd: '',
              ikkatsuFlg: false
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstTeikeiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元

          self.conditions = { ...self.conditions, ...c }
          var ikkatsuFlgBool = c.ikkatsuFlg === 'true'
          this.conditions.ikkatsuFlg = ikkatsuFlgBool
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTeikeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTeikeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTeikeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstTeikeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2mstd0350/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
                juchuHacchuCd: self.conditions.juchuHacchuCd,
                hacchusakiKbnCd: self.conditions.hacchusakiKbnCd,
                hinmokuSbtCd: self.conditions.hinmokuSbtCd,
                ikkatsuFlg: self.conditions.ikkatsuFlg
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            juchuHacchuCd: self.conditions.juchuHacchuCd,
            hacchusakiKbnCd: self.conditions.hacchusakiKbnCd,
            hinmokuSbtCd: self.conditions.hinmokuSbtCd,
            ikkatsuFlg: self.conditions.ikkatsuFlg
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              teikeiKihonNo: '',
              teikeiKihonNm: '',
              juchuHacchuCd: '',
              hacchusakiKbnCd: '',
              teikeiCourseNo: '',
              teikeiCourseNm: '',
              tantoEigyoshoCd: '',
              torihikisakiCd: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              hinmokuSbtCd: '',
              hinmeiCd: '',
              ikkatsuFlg: false
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCD2mstd0350/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
